export const multiconvergenceOfferPopupReducer = (state, action) => ({
  ...state,
  allInOne: {
    ...state.allInOne,
    ...{
      ...action.payload,
    },
    requestData: action.resetError ? {} : (action.payload.requestData
        || (state.allInOne && state.allInOne.requestData)),
  },
});
